export default {
  title: 'Contact & synchronisatie',
  labels: {
    occ_phone_number: 'Telefoonnummer callcenter',
    company_phone_number: 'Telefoonnummer restaurant',
    has_google_business_sync: 'Synchroniseren met Google Business',
    has_foodamigos_sync: 'Synchroniseren met Foodamigos-diensten',
  },
  placeholders: {
    occ_phone_number: 'Selecteer telefoonnummer uit de lijst',
  },
};
